import React from "react"

import desktop from "../../../../images/DynamicImageGridBackgrounds/desktop.svg"
import mobile from "../../../../images/DynamicImageGridBackgrounds/mobile.svg"
import tablet from "../../../../images/DynamicImageGridBackgrounds/tablet.svg"
import screenResponsive from "../../../../utils/screenResponsive"

const Background = () => {
  const isTablet = screenResponsive(992)
  const isMobile = screenResponsive(768)

  if (isMobile) {
    return <img src={mobile} alt="" />
  }
  if (isTablet) {
    return <img src={tablet} alt="" />
  }
  return <img src={desktop} alt="" />
}

export default Background
